import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { ApiGenericResponse } from "../ApiGenericResponse";
import { GetSupportedModelsResponse } from "./GetSupportedModelsResponse";

const ENDPOINT = "/device/supportedModels";

export class GetSupportedModelsCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";

    constructor() {
        super();
    }

    public async execute(): Promise<GetSupportedModelsResponse> {
        let res = await this.executeCommand();
        return new GetSupportedModelsResponse(res);
    }
}
